<template lang="html">
  <v-layout row wrap justify-center align-center style="height: 100%;">
    <v-progress-circular v-if="progress" :size="100" color="primary" :width="8" :indeterminate="progress"></v-progress-circular>
    <iframe v-else :src="linkonemeet" style="width: 100vw !important; height: calc(100vh - 64px) !important; border-width: 0px !important;" allow="camera *; microphone; autoplay; display-capture;"></iframe>
  </v-layout>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      linkonemeet: '',
      progress: false,
      token: '',
      one_id: ''
    }
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    // console.log(decoded)
    this.token = decoded['tokenuser']
    this.get_oneid()
  },
  methods: {
    get_oneid () {
      this.progress = true
      this.axios.get(process.env.APIgo_api + `/v1/getOneID/${this.token}`).then((response) => {
        if (response.data.status === 'success') {
          this.one_id = response.data.one_id
          // get_encode_shared_token
          this.axios.post(process.env.APIimage + '/api/v1/get_shared_token',
          { user_id: this.one_id }).then((response) => {
            if (response.data.status === 'success') {
              this.progress = false
              this.linkonemeet = `${process.env.linkonemeet}${response.data.data.shared_token}`
              // this.linkonemeet = `${process.env.linkonemeet}${response.data.data.encode_shared_token}`
              // console.log(this.linkonemeet)
            }
          }).catch(error => {
            console.log(error)
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          })
        }
      }).catch(error => {
        console.log(error)
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
      })
    },
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/chat/onemeet/LayoutOnemeet.vue